import * as React from "react";
const SvgChangePassword = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M21.7 2.8h-3.15V1.05C18.55.476 18.074 0 17.5 0s-1.05.476-1.05 1.05v25.9c0 .574.476 1.05 1.05 1.05s1.05-.476 1.05-1.05V25.2h3.15c3.094 0 5.6-2.506 5.6-5.6V8.4c0-3.094-2.506-5.6-5.6-5.6M5.6 2.8A5.6 5.6 0 0 0 0 8.4v11.2c0 3.094 2.506 5.6 5.6 5.6h7c.77 0 1.4-.63 1.4-1.4V4.2c0-.77-.63-1.4-1.4-1.4zm.238 11.732q-.105.252-.294.462-.21.189-.462.294c-.168.07-.35.112-.532.112s-.364-.042-.532-.112a1.6 1.6 0 0 1-.462-.294 2 2 0 0 1-.308-.462A1.4 1.4 0 0 1 3.15 14c0-.364.154-.728.406-.994l.21-.168a1 1 0 0 1 .252-.126.9.9 0 0 1 .252-.084c.476-.098.952.056 1.274.378.252.266.406.63.406.994 0 .182-.042.364-.112.532m4.9 0q-.105.252-.294.462-.21.189-.462.294c-.168.07-.35.112-.532.112s-.364-.042-.532-.112a1.6 1.6 0 0 1-.462-.294 1.39 1.39 0 0 1-.294-1.526c.07-.182.168-.322.294-.462.518-.518 1.456-.518 1.988 0 .252.266.406.63.406.994 0 .182-.042.364-.112.532"
    />
  </svg>
);
export default SvgChangePassword;
